import { APP_CONFIG } from 'services/app-config'

export const CONFIG = {
  api: {
    discounts: `${APP_CONFIG.care_cluster}/ms-discounts/availabilities`,
  },
}
